<template>
    <div v-if="!isLoaded">
        <div>
            <div class="row">
                <div class="col-lg-12">
                    Cargando...
                </div>
            </div>
        </div>
    </div>
    <div v-if="isLoaded">
        <form @submit.prevent="handleSubmit">
            <div>
                <!-- Cliente y Proyecto -->
                <div class="row mb-3">
                    <div class="col-lg-4">
                        <label class="form-label">Cliente:</label>
                        <select v-model="recordData.client_id" class="form-control" @change="onClientChange">
                            <option value="">Selecciona Cliente</option>
                            <option v-for="client in clients" :key="client.client_id" :value="client.client_id">
                                {{ client.client }}
                            </option>
                        </select>
                    </div>
                    <div class="col-lg-8">
                        <label class="form-label">Proyecto:</label>
                        <select v-model="recordData.project_id" class="form-control">
                            <option value="">Selecciona Proyecto</option>
                            <option v-for="project in projects" :key="project.project_id" :value="project.project_id">
                                {{ project.identifier }} - {{ project.project }}
                            </option>
                        </select>
                    </div>
                </div>

                <!-- Actividad y Fecha -->
                <div class="row mb-3">
                    <div class="col-lg-8">
                        <label for="activity" class="form-label">Actividad:</label>
                        <select v-model="recordData.activity_id" class="form-control">
                            <option value="">Selecciona Actividad</option>
                            <option v-for="act in activities" :key="act.activity_id" :value="act.activity_id">
                                {{ act.activity }}
                            </option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label for="eventDate" class="form-label">Fecha:</label>
                        <input type="date" id="eventDate" v-model="recordData.date" class="form-control" required />
                    </div>
                </div>

                <!-- Tipo de registro: Evento o Horas -->
                <div class="row mb-3">
                    <div class="col-lg-12 d-flex justify-content-center">
                        <div class="form-check form-switch">
                            <input v-model="recordData.is_event" class="form-check-input" type="checkbox"
                                id="isEvent" />
                            <label class="form-check-label" for="isEvent">
                                Es un Evento (con hora de inicio y fin)
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Si NO es evento: mostrar campo de horas -->
                <div v-if="!recordData.is_event" class="row mb-3 d-flex justify-content-center">
                    <div class="col-lg-3">
                        <label for="hours" class="form-label">Horas:</label>
                        <input type="number" min="0.25" step="0.01" id="hours" v-model="recordData.total_hours"
                            class="form-control" />
                    </div>
                    <div class="col-lg-3">
                        <label for="businessLine" class="form-label">Línea Negocio:</label>
                        <select id="businessLine" v-model="recordData.business_line" class="form-select">
                            <option value="" disabled>Seleccione una opción</option>
                            <option v-for="line in businessLines" :key="line.id" :value="line.id">
                                {{ line.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <!-- Si es evento: mostrar horas de inicio y fin -->
                <div v-if="recordData.is_event" class="row mb-3">
                    <div class="col-lg-4">
                        <label for="startTime" class="form-label">Hora Inicio:</label>
                        <input type="time" id="startTime" v-model="recordData.start_time" class="form-control"
                            required />
                    </div>
                    <div class="col-lg-4">
                        <label for="endTime" class="form-label">Hora Fin:</label>
                        <input type="time" id="endTime" v-model="recordData.end_time" class="form-control" required />
                    </div>
                    <div class="col-lg-4">
                        <label for="businessLine" class="form-label">Línea Negocio:</label>
                        <select id="businessLine" v-model="recordData.business_line" class="form-select">
                            <option value="" disabled>Seleccione una opción</option>
                            <option v-for="line in businessLines" :key="line.id" :value="line.id">
                                {{ line.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <!-- Campos de estado  -->

                <div class="row mb-3 d-flex">

                    <div class="col-lg-4 d-flex flex-column align-items-center">
                        <label class="form-label">Tiempo Extra?</label>
                        <div class="form-check form-switch ms-2 mt-2">
                            <input v-model="recordData.is_extra_time" class="form-check-input" type="checkbox" />
                        </div>
                    </div>
                    <div class="col-lg-4 d-flex flex-column align-items-center">
                        <label class="form-label">Enviado?</label>
                        <div class="form-check form-switch ms-2 mt-2">
                            <input v-model="recordData.sent" class="form-check-input" type="checkbox" />
                        </div>
                    </div>
                    <div class="col-lg-4 d-flex flex-column align-items-center">
                        <label class="form-label">En Planta?</label>
                        <div class="form-check form-switch ms-2 mt-2">
                            <input v-model="recordData.on_site" class="form-check-input" type="checkbox" />
                        </div>
                    </div>

                </div>

                <!-- Autorización Project Manager -->

                <div class="row mb-3 d-flex justify-content-center">
                    <div class="col-lg-6 d-flex flex-column align-items-center">
                        <label class="form-label">Autorizado por PM?</label>
                        <div class="form-check form-switch ms-2 mt-2">
                            <input v-model="recordData.auth_by_pm" class="form-check-input" type="checkbox"
                                @change="onAuthPmChange" />
                        </div>
                    </div>
                    <div v-if="recordData.auth_by_pm" class="col-lg-6">
                        <label class="form-label">Project Manager:</label>
                        <select v-model="recordData.auth_pm_id" class="form-control">
                            <option value="">Selecciona PM</option>
                            <option v-for="pm in projectManagers" :key="pm.user_id" :value="pm.user_id">
                                {{ pm.name }} {{ pm.last_name }}
                            </option>
                        </select>
                    </div>
                </div>

                <!-- Notas -->
                <div class="row mb-4">
                    <div class="col-lg-12">
                        <label for="notes" class="form-label">Notas:</label>
                        <textarea id="notes" v-model="recordData.notes" class="form-control" rows="3"></textarea>
                    </div>
                </div>

                <button size="lg" type="submit" class="btn btn-warning w-100 mb-0">Guardar Cambios</button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { onMounted, ref, defineProps } from 'vue';
import axios from 'axios';

const token = localStorage.getItem('authToken');
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const isLoaded = ref(false);
const showOnSite = ref(true);

const props = defineProps({
    selectedData: Object,
});

const recordData = ref({
    date: '',
    start_time: '',
    end_time: '',
    total_hours: 0,
    is_billable: false,
    charge_account: null,
    activity_id: '',
    client_id: '',
    project_id: '',
    on_site: false,
    notes: '',
    is_auth: false,
    auth_by: null,
    is_extra_time: false,
    sent: false,
    auth_by_pm: false,
    auth_pm_id: null,
    automated: false,
    business_line: null,
    active: true,
    is_event: false
});

const businessLines = [
    { id: 100, name: '100' },
    { id: 200, name: '200' },
    { id: 300, name: '300' },
    { id: 400, name: '400' },
    { id: 410, name: '410' },
    { id: 900, name: '900' },
]

const activities = ref([]);
const clients = ref([]);
const projects = ref([]);
const projectManagers = ref([])

const verifyIsNexon = (clientId) => {
    showOnSite.value = clientId !== 2;
};

const onClientChange = () => {
    verifyIsNexon(recordData.value.client_id);
    recordData.value.project_id = '';
    fetchProjects()
};


const onAuthPmChange = () => {
    if (!recordData.value.auth_by_pm) {
        recordData.value.auth_pm_id = null;
    }
};

const fetchActivities = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/user-activities`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        activities.value = response.data;
    } catch (error) {
        console.error('Error al obtener actividades:', error);
    }
};

const fetchClients = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-all-clients`, {}, {
            headers: { Authorization: `Bearer ${token}` },
        });
        clients.value = response.data;
    } catch (error) {
        console.error('Error al obtener clientes:', error);
    }
};

const fetchProjects = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-client-projects`, { client_id: recordData.value.client_id }, {
            headers: { Authorization: `Bearer ${token}` },
        });
        projects.value = response.data;
    } catch (error) {
        console.error('Error al obtener proyectos:', error);
    }
};

const fetchPMs = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-project-managers`, {}, {
            headers: { Authorization: `Bearer ${token}` },
        });
        projectManagers.value = response.data;
    } catch (error) {
        console.error('Error al obtener proyectos:', error);
    }
}


const loadRecordEditInfo = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/complete-edit-tr-info`,
            { time_record_id: props.selectedData.time_record_id },
            { headers: { Authorization: `Bearer ${token}` } }
        );

        const data = response.data;

        recordData.value = {
            date: new Date(data.date).toISOString().split('T')[0],
            start_time: formatTime(data.start_time),
            end_time: formatTime(data.end_time),
            total_hours: data.total_hours,
            is_billable: data.is_billable,
            charge_account: data.charge_account,
            activity_id: data.activity_id,
            client_id: data.client_id,
            project_id: data.project_id,
            on_site: data.on_site,
            notes: data.notes,
            is_auth: data.is_auth,
            auth_by: data.auth_by,
            is_extra_time: data.is_extra_time,
            sent: data.sent,
            auth_by_pm: data.auth_by_pm,
            auth_pm_id: data.auth_pm_id,
            automated: data.automated,
            business_line: data.business_line,
            active: data.active,
            is_event: data.is_event
        };

        verifyIsNexon(data.client_id);
        fetchProjects();
        isLoaded.value = true;
    } catch (error) {
        console.error('Error al cargar registro:', error);
    }
};

const handleSubmit = async () => {

    if (recordData.value.is_event) {
        const startTime = new Date(`1970-01-01T${recordData.value.start_time}Z`);
        const endTime = new Date(`1970-01-01T${recordData.value.end_time}Z`);

        if (startTime >= endTime) {
            alert('La hora de inicio debe ser menor que la hora de fin.');
            return;
        }
    }

    const body = {
        time_record_id: props.selectedData.time_record_id,
        ...recordData.value
    };


    try {
        const response = await axios.post(`${API_BASE_URL}/edit-complete-tr`, body, {
            headers: { Authorization: `Bearer ${token}` },
        });

        if (response.status === 200 && response.data.success) {
            alert(response.data.msg);
            window.location.reload();
        }
    } catch (error) {
        console.error('Error al actualizar:', error);
        alert(error.response?.data?.msg || 'Error al actualizar el registro');
    }
};

const formatTime = (timeString) => {
    if (!timeString) return '';
    const time = new Date(timeString);
    const hours = time.getUTCHours().toString().padStart(2, '0');
    const minutes = time.getUTCMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
};

const getData = async () => {
    await Promise.all([
        loadRecordEditInfo(),
        fetchActivities(),
        fetchClients(),
        fetchPMs(),
    ]);
}

onMounted(async () => {
 await getData ();
});
</script>